// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"48":"d7deedbf","227":"222f0aac","648":"b0cde067"}[chunkId] + ".chunk.js";
};